(function () {
  'use strict';
  var dialog = document.getElementById('bioss-recombinant-sample');
  var node = document.querySelector('[data-bioss-sample-config]');
  if (!dialog || !node || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var labels = config.labels;
  if (!labels || typeof labels !== 'object') return;
  dialog.dataset.ready = 'true';
  var select = dialog.querySelector('[data-sample-choice]');
  var add = dialog.querySelector('[data-sample-add]');
  var status = dialog.querySelector('[data-sample-status]');
  var skip = dialog.querySelector('[data-sample-skip]');
  var active = null, detail = null, busy = false, waiting = false, completed = false, navigating = false, sequence = 0;
  var seen = Object.create(null);
  var displayed = Object.create(null);
  var preferred = Object.create(null);
  function number(value) { return Number.isSafeInteger(value) && value > 0; }
  function wasShown(productId) {
    if (!number(Number(productId))) return false;
    if (displayed[productId]) return true;
    try { return sessionStorage.getItem('bioss-recombinant-shown:' + productId) === '1'; } catch (_) { return false; }
  }
  function productUrl(value, handle) {
    try { var u = new URL(value, location.origin); return u.origin === location.origin && /^\/[a-zA-Z-]*\/?products\//.test(u.pathname) && u.pathname.endsWith('/products/' + handle) && !u.search && !u.hash ? u.href : ''; } catch (_) { return ''; }
  }
  function imageUrl(value) {
    try { var u = new URL(value, location.origin); return u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.origin === location.origin || /(^|\.)biossusa\.com$/.test(u.hostname)) ? u.href : ''; } catch (_) { return ''; }
  }
  function valid(data, item) {
    return data && data.eligible === true && data.limit === 1 && typeof data.offer_id === 'string' && data.offer_id.length < 200 &&
      data.source_product_id === item.product_id && typeof data.target === 'string' && Array.isArray(data.choices) && data.choices.length > 0 && data.choices.length <= 30 &&
      data.choices.every(function (c) { return number(c.variant_id) && number(c.product_id) && c.available === true && c.volume_ul === 20 && typeof c.handle === 'string' && /^[a-z0-9-]+$/.test(c.handle) && typeof c.sku === 'string' && /-20ul$/i.test(c.sku) && typeof c.title === 'string' && productUrl(c.url, c.handle); });
  }
  function selected() { return active && active.choices[Number(select.value)]; }
  function renderChoice() {
    var c = selected(); if (!c) return;
    dialog.querySelector('[data-sample-name]').textContent = c.title;
    dialog.querySelector('[data-sample-sku]').textContent = c.sku;
    dialog.querySelector('[data-sample-link]').href = productUrl(c.url, c.handle);
    var img = dialog.querySelector('[data-sample-image]'), src = imageUrl(c.image);
    img.onerror = function () { img.hidden = true; img.closest('figure').hidden = true; };
    img.closest('figure').hidden = !src;
    img.hidden = !src; img.alt = c.title; if (src) img.src = src; else img.removeAttribute('src');
  }
  function resume() {
    var previous = detail; detail = null; waiting = false; active = null;
    if (previous && !previous.page_entry && !wasShown(previous.item && previous.item.product_id) && !navigating && dialog.isConnected) document.dispatchEvent(new CustomEvent('bioss:secondary-resume', { detail: previous }));
  }
  function open(data) {
    active = data; completed = false; navigating = false;
    status.textContent = ''; add.hidden = false; add.disabled = false; add.textContent = labels.add;
    dialog.querySelector('[data-sample-heading]').textContent = detail && detail.page_entry ? labels.entry_heading : labels.confirmed;
    if (data.primary_required) { add.textContent = labels.choose_primary; status.textContent = labels.entry_instruction; }
    skip.textContent = labels.skip; select.disabled = false; select.textContent = '';
    data.choices.forEach(function (c, i) { var o = document.createElement('option'); o.value = String(i); o.textContent = c.sku; select.appendChild(o); });
    var preferredIndex = data.choices.findIndex(function (c) { return c.variant_id === preferred[data.source_product_id]; });
    select.value = String(Math.max(0, preferredIndex)); select.hidden = data.choices.length === 1; dialog.querySelector('label[for="bioss-sample-choice"]').hidden = select.hidden;
    dialog.querySelector('[data-sample-context]').textContent = labels.context.replace('[target]', data.target);
    renderChoice();
    if (window.jQuery) window.jQuery('.cart-preview').stop(true, true).hide();
    dialog.showModal();
    displayed[data.source_product_id] = true;
    try { sessionStorage.setItem('bioss-recombinant-shown:' + data.source_product_id, '1'); } catch (_) {}
    document.body.classList.add('bioss-sample-open');
    (select.hidden ? dialog.querySelector('[data-sample-close]') : select).focus();
    if (!detail || !detail.page_entry) seen[data.source_product_id] = true;
  }
  function offerFirst(eventDetail) {
    var adapter = window.BiossSampleRequest, item = eventDetail && eventDetail.item;
    if (!config.enabled) return false;
    if (!dialog.isConnected || !adapter || adapter.ready !== true || typeof adapter.getOffer !== 'function' || typeof adapter.claim !== 'function' || !item || !number(item.product_id)) return false;
    if (waiting && detail && detail.page_entry && !eventDetail.page_entry) { sequence++; waiting = false; detail = null; }
    if (waiting || busy || dialog.open) return true;
    if (seen[item.product_id]) return false;
    if (document.querySelector('dialog[open]')) return false;
    detail = eventDetail; waiting = true; var run = ++sequence;
    var timer = window.setTimeout(function () { if (run === sequence && waiting && !dialog.open) { sequence++; resume(); } }, 4500);
    Promise.resolve().then(function () { return adapter.getOffer({ item: item, page_entry: eventDetail.page_entry === true }); }).then(function (data) {
      if (run !== sequence) return;
      if (!valid(data, item) || document.querySelector('dialog[open]')) { resume(); return; }
      open(data);
    }).catch(function () { if (run === sequence) resume(); }).finally(function () { window.clearTimeout(timer); });
    return true;
  }
  window.BiossRecombinantSample = { offerFirst: offerFirst, wasShown: wasShown };
  select.addEventListener('change', renderChoice);
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var controls = Array.from(dialog.querySelectorAll('button:not([disabled]),select:not([disabled]),a[href]')).filter(function (el) { return !el.hidden && el.getClientRects().length; });
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function close() { if (!busy) dialog.close(); }
  dialog.querySelectorAll('[data-sample-close]').forEach(function (button) { button.addEventListener('click', close); });
  dialog.addEventListener('cancel', function (event) { if (busy) event.preventDefault(); });
  dialog.addEventListener('close', function () { document.body.classList.remove('bioss-sample-open'); if (detail && detail.trigger && detail.trigger.isConnected) detail.trigger.focus(); resume(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
  dialog.querySelector('[data-sample-cart]').addEventListener('click', function (event) { if (busy) event.preventDefault(); else navigating = true; });
  add.addEventListener('click', function () {
    var c = selected(), adapter = window.BiossSampleRequest;
    if (busy || completed || !dialog.open || !c || !adapter || adapter.ready !== true) return;
    if (active.primary_required) {
      preferred[active.source_product_id] = c.variant_id;
      close();
      var form = document.getElementById('AddToCartForm');
      if (form) {
        form.scrollIntoView({block:'center',behavior:'auto'});
        var control = form.querySelector('select[name="id"],input[name="id"]:not([type="hidden"]),button[type="submit"]');
        if (control) control.focus({preventScroll:true});
      }
      return;
    }
    busy = true; add.disabled = true; select.disabled = true; add.textContent = labels.adding; status.textContent = '';
    var requestId = window.crypto.randomUUID();
    Promise.resolve().then(function () { return adapter.claim({ offer_id: active.offer_id, source_product_id: active.source_product_id, variant_id: c.variant_id, quantity: 1, request_id: requestId }); }).then(function (result) {
      if (result && result.rolled_back === true) {
        completed = true; add.hidden = true; skip.textContent = labels.continue; status.textContent = labels.failed;
        return;
      }
      if (!result || result.sample_added !== true || result.variant_id !== c.variant_id || result.quantity !== 1) throw new Error('unverified');
      completed = true; add.hidden = true; skip.textContent = labels.continue; status.textContent = labels.added;
      if (result.cart && window.StyleHatch && typeof window.StyleHatch.updateCartButton === 'function') window.StyleHatch.updateCartButton(result.cart);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {
      completed = true; add.hidden = true; skip.textContent = labels.continue; status.textContent = labels.uncertain;
    }).finally(function () { busy = false; add.textContent = labels.add; skip.focus(); });
  });
  function fallback(event) { var secondary = document.getElementById('bioss-secondary-upsell'); if (!secondary || secondary.dataset.ready !== 'true') offerFirst(event.detail); }
  document.addEventListener('bioss:product-added', fallback);
  function pageEntry() {
    if (config.eligible_customer && number(config.page_product_id)) offerFirst({item:{product_id:config.page_product_id},page_entry:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pageEntry, {once:true});
  else pageEntry();
  document.addEventListener('shopify:section:unload', function unload(event) {
    if (!event.target.contains(dialog)) return;
    sequence++; navigating = true; if (dialog.open) dialog.close(); else resume();
    document.removeEventListener('bioss:product-added', fallback); document.removeEventListener('shopify:section:unload', unload);
    document.removeEventListener('DOMContentLoaded', pageEntry);
    delete window.BiossRecombinantSample;
  });
})();
